const RootPath = window.g.baseUrl
const apis = {
  /* 成品 api */
  // 根据产品类别ID获取产品列表
  getProductsForMakebook: RootPath + 'plugin/plate/makebook/GetProducts',
  // 成品票据列表
  getProductPrintNoteList: RootPath + 'plugin/plate/makebook/GetProductPrintNoteList',
  //成品明细
  getProductPrintNoteDetail: RootPath + 'plugin/plate/makebook/GetProductPrintNoteDetail',
  //打印时，将生产数据同步到新数据库
  asyncMakebookSealoutput: RootPath + 'plugin/plate/makebook/AsyncMakebookSealoutput',
  // 成品出库票据列表
  getProductPrintOutNoteList: RootPath + 'plugin/plate/makebook/GetProductPrintOutNoteList',
  //打印出库票据
  printMakebookSealoutput: RootPath + 'plugin/plate/makebook/PrintMakebookSealoutput',
  //获取所有库存
  getProductPositionList: RootPath + 'plugin/plate/makebook/GetProductPositionList',
  //成品移库
  updateProductPosition: RootPath + 'plugin/plate/makebook/UpdateProductPosition',
  //获取汇总数据
  getProductsSummaryList: RootPath + 'plugin/plate/makebook/GetProductsSummaryList',
  //获取汇总明细
  getProductsDetailData: RootPath + 'plugin/plate/makebook/GetProductsDetailData',
  //导出excel
  exportProductsSummaryList: RootPath + 'plugin/plate/makebook/ExportProductsSummaryList',
  //获取不良品数据
  getRejectedList: RootPath + 'plugin/plate/makebook/getRejectedList',
  //保存修复数量
  saveRejected:RootPath + 'plugin/plate/makebook/saveRejected',
  //删除打印票据
  delNotes:RootPath + 'plugin/plate/makebook/DelNotes',
  //删除样本册
  delSample: RootPath + 'plugin/plate/makebook/DelSample'
}

export default apis
